import { observe, toJS } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { Prompt, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import ButtonRow from "src/Components/ButtonRow";
import DataTable from "src/Components/DataTable";
import { IList } from "src/Components/DataTable/DataTable";
import { EButton, EInput, EInputMask } from "src/Components/EInput";
import { WellFooter } from "src/Components/Footer/WellFooter";
import { IEBPExpenseType } from "src/Interfaces/TestInterface";
import { IWellCloseReview, IWellCloseReviewExpense, WellCloseReviewExpense } from "src/Interfaces/WellInterface";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import WorkflowHeader from "../../WorkflowHeader/WorkflowHeader";
import WellCloseButton from "../WellCloseButton";
import WellRevertCloseButton from "../WellRevertCloseButton";
import CostsTotalHeader from "./CostsTotalHeader";

const mask = new EInputMask();
@inject('stores')
@observer
class EbpReview extends React.Component {
    public props: any;
    private MessageStore: any;
    private TestsStore: TestsStore;
    private WellsStore: WellsStore; 
    private wellReviewDisposer: any;

    public state = {
        dataSet: undefined as unknown as IList,
        expenseList: [] as IEBPExpenseType[],
        expenseListMaster: [] as IEBPExpenseType[],
        isDirty: false,
        modal: false,
        modalDataSet: undefined as unknown as IList,
        modalDataSetMaster: undefined as unknown as IList,
        newInventoryList: [] as boolean[],
        newInventoryListMaster: [] as boolean[],
        showMasterItems: false,
        wellCloseReview: undefined as unknown as IWellCloseReview,
    };

    constructor(props: any) {
        super(props);
        this.MessageStore = props.stores.MessageStore;
        this.WellsStore = props.stores.WellsStore;
        this.TestsStore = props.stores.TestsStore;
    }

    public componentDidMount() {
        this.createObservers();
        if (this.WellsStore.well) {
            this.WellsStore.getWellCloseReview();
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(() => {
                    this.WellsStore.getWellCloseReview();
                });
        }

        this.getExpenseTypes().then(() => {
            this.getMasterExpenseList();
        });
    }

    public componentWillUnmount() {
        this.disposeObservers();
    }

    private createObservers() {
        this.wellReviewDisposer = observe(this.WellsStore, 'wellCloseReview', change => {
            this.setState({
                wellCloseReview: toJS(change.newValue)
            }, () => this.formatDataTable());
            return change;
        });
    }

    private disposeObservers() {
        this.wellReviewDisposer();
    }

    private getExpenseTypes() {
        return this.TestsStore.getExpenseTypes(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    expenseList: data
                }, () => {
                    this.formatModalDataTable();
                });
            }
        );
    }

    private getMasterExpenseList() {
        this.TestsStore.getExpenseTypes()
            .then(expenseMasterList => {
                if (expenseMasterList) {
                    const expenseListMaster = expenseMasterList.filter((expense: IEBPExpenseType) => 
                        !this.state.expenseList.some(p => p.id === expense.id)
                    );
                    this.setState({expenseListMaster}, () => {
                        this.formatModalDataTable();
                    });
                }
            });
    }
    
    private handleListToggle = () => {
        this.setState({
            showMasterItems: !this.state.showMasterItems,
        });
    }

    private toggleModal = () => {
        if ( this.state.modal ) {
            this.setState({
                newInventoryList: []
            });
        } else {
            this.getExpenseTypes();
            this.setState({
                showMasterItem: false,
            });
        }
        this.setState({
            modal: !this.state.modal
        }, () => {
            this.formatModalDataTable();
        });
    }

    private getDelibleList = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const wellCloseReviewExpenses = wellCloseReview.expenses;
        return wellCloseReviewExpenses.map(wcre => wcre.isDelible);
    }
    private formatDataTable = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const headers = [
            'Expense',
            'Type',
            'Unit Price',
            'Taxable',
            'Total Units',
            'Total Price',
            'Adjustments',
            'Difference ($)',
            'Final (Units)',
            'Final ($)',
        ];

        if (wellCloseReview === undefined) {
            this.setState({dataSet: { headers, rows: []}});
        }

        const wellCloseReviewExpenses = wellCloseReview.expenses;
        const rows = wellCloseReviewExpenses.map((wcre, index) => {
            return [
                {
                    content: wcre.expenseType.name
                },
                {
                    content: wcre.expenseType.isRental ? 'Rental' : 'Service',
                },
                {
                    content: wcre.isDelible ? this.renderUnitPriceInput(wcre, index) : mask.currency(wcre.unitPrice),
                    sortItem: wcre.unitPrice,
                    type: wcre.isDelible ? 'render' : '',
                },
                {
                    content: this.renderTaxableCheckbox(wcre, index),
                    sortItem: wcre.isTaxable,
                    type: 'render',
                },
                {
                    content: wcre.totalUnits
                },
                {   
                    content: mask.currency(wcre.totalPrice),
                    sortItem: wcre.totalPrice
                },
                {
                    content: this.renderAdjustmentsInput(wcre, index),
                    sortItem: wcre.adjustments,
                    type: 'render'
                },
                {
                    content: this.renderDifferencePrice(wcre),
                    sortItem: wcre.differencePrice,
                    type: 'render'
                },
                {
                    content: this.renderFinalUnits(wcre, index),
                    sortItem: wcre.finalUnits,
                    type: 'render'
                },
                {
                    content: this.renderFinalPrice(wcre),
                    sortItem: wcre.finalPrice,
                    type: 'render'
                },
            ];
        });

        this.setState({
            dataSet: { headers, rows }
        });
    }

    private formatModalDataTable() {
        const newDataList: any[] = [];
        const newDataListMaster: any[] = [];
        const tableHeaders = [
            'EBP Item',
            'Service Type',
            'Price'
        ];
        if ( this.state.expenseList ) {
            this.state.expenseList.map((expense: IEBPExpenseType, index: number) => {
                const newObject = [
                    {
                        content: expense.name,
                    },
                    {
                        content: expense.isRental ? "Rental" : "Service",
                    },
                    {
                        content: expense.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }

        if ( this.state.expenseListMaster ) {
            this.state.expenseListMaster.map((expense: IEBPExpenseType, index: number) => {
                const newObject = [
                    {
                        content: expense.name,
                    },
                    {
                        content: expense.isRental ? "Rental" : "Service",
                    },
                    {
                        content: expense.retailPrice
                    }
                ];
                newDataListMaster.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };

        const listStructureMaster = {
            headers: tableHeaders,
            rows: newDataListMaster,
        };

        this.setState({
            modalDataSet: listStructure,
            modalDataSetMaster: listStructureMaster,
        });
    }

    private handleSave = () => {
        const wellCloseReview = this.state.wellCloseReview;
        const ebpReview = wellCloseReview.expenses;
        this.state.expenseList.map((expenseType: IEBPExpenseType, index: number) => {
            if (this.state.newInventoryList[index]) {
                const newInventoryExpense = new WellCloseReviewExpense();
                newInventoryExpense.expenseType = expenseType;
                newInventoryExpense.expenseTypeId = expenseType.id;
                newInventoryExpense.isTaxable = expenseType.isTaxable;
                newInventoryExpense.unitPrice = expenseType.retailPrice;
                newInventoryExpense.isDelible = true;
                ebpReview.push(newInventoryExpense);
            }
        });

        this.state.expenseListMaster.map((expenseType: IEBPExpenseType, index: number) => {
            if (this.state.newInventoryListMaster[index]) {
                const newInventoryExpense = new WellCloseReviewExpense();
                newInventoryExpense.expenseType = expenseType;
                newInventoryExpense.expenseTypeId = expenseType.id;
                newInventoryExpense.isTaxable = expenseType.isTaxable;
                newInventoryExpense.unitPrice = expenseType.retailPrice;
                newInventoryExpense.isDelible = true;
                ebpReview.push(newInventoryExpense);
            }
        });

        
        this.setState({
            isDirty: true,
            wellCloseReview
        }, () => {
            this.formatDataTable();
        });
        this.WellsStore.updateWellCloseReview(wellCloseReview);
        this.toggleModal();
    }

    private handleMultiSelect = (index: number) => {
        if (this.state.showMasterItems) {
            const newInventoryListMaster = this.state.newInventoryListMaster;
            newInventoryListMaster[index] = !newInventoryListMaster[index];
            this.setState({newInventoryListMaster});    
        } else {
            const newInventoryList = this.state.newInventoryList;
            newInventoryList[index] = !newInventoryList[index];
            this.setState({newInventoryList});
        }
    }

    private handleTaxableClick = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        wellCloseReview.expenses[index].isTaxable = !wellCloseReview.expenses[index].isTaxable;
        this.setState({wellCloseReview});
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private renderTaxableCheckbox = (wcre: IWellCloseReviewExpense, index: number) => () => {
        return (
            <div className="multi-select-row">
                <Input onChange={this.handleTaxableClick(index)} checked={wcre.isTaxable} type="checkbox" value="" />
            </div>
        );
    }

    private renderAdjustmentsInput = (wcre: IWellCloseReviewExpense, index: number) => () => {
        return (
            <EInput
                key={"adjustments" + wcre.id}
                name={"adjustments" + index}
                id={"adjustments" + index}
                value={wcre.adjustments}
                data-validation="negative"
                onChange={this.handleChangeAdjustments(index)}
            />
        );
    }

    private renderUnitPriceInput = (wcre: IWellCloseReviewExpense, index: number) => () => {
        return (
            <EInput
                key={"unitPrice" + wcre.id}
                name={"unitPrice" + index}
                id={"unitPrice" + index}
                value={wcre.unitPrice}
                data-validation="decimal"
                data-mask="currency"
                onChange={this.handleChangeUnitPrice(index)}
            />
        );
    }

    private renderDifferencePrice = (wcre: IWellCloseReviewExpense) => () => {
        return mask.currency(wcre.differencePrice);
    }

    private renderFinalUnits = (wcre: IWellCloseReviewExpense, index: number) => () => {
        return <EInput
                    key={"finalUnits" + wcre.id}
                    name={"finalUnits" + index}
                    id={"finalUnits" + index}
                    value={wcre.finalUnits}
                    data-validation="decimal"
                    disabled={true}
                />;
    }

    private renderFinalPrice = (wcre: IWellCloseReviewExpense) => () => {
        return mask.currency(wcre.finalPrice);
    }

    private handleChangeAdjustments = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        const wcre = wellCloseReview.expenses[index];
        wcre.adjustments = event.target.value;
        if (Number.isInteger(Number(wcre.adjustments))) {
            wcre.differencePrice = Number(wcre.adjustments) * wcre.unitPrice;
            wcre.finalUnits = Number(wcre.adjustments) + wcre.totalUnits;
            wcre.finalPrice = wcre.finalUnits * wcre.unitPrice;
        }

        this.setState({isDirty: true, wellCloseReview});
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private handleChangeUnitPrice = (index: number) => (event: any) => {
        const wellCloseReview = this.state.wellCloseReview;
        const wcre = wellCloseReview.expenses[index];
        wcre.unitPrice = event.target.value;
        if (Number.isFinite(Number(wcre.unitPrice))) {
            wcre.differencePrice = Number(wcre.adjustments) * Number(wcre.unitPrice);
            wcre.finalPrice = wcre.finalUnits * Number(wcre.unitPrice);
        } else {
            wcre.differencePrice = 0;
            wcre.finalPrice = 0;
        }

        this.setState({isDirty: true, wellCloseReview});
        this.WellsStore.updateWellCloseReview(wellCloseReview);
    }

    private updateWellCloseReview = () => {
        this.WellsStore.saveWellCloseReview(this.state.wellCloseReview)
            .then(data => {
                if (data) {
                    this.setState({isDirty: false});
                }
            });
    }



    public handleDelete = (index: number) => {
        const wellCloseReview = this.state.wellCloseReview;
        const wcreId =  wellCloseReview.expenses[index].id;
        this.WellsStore.deleteEBPItem(wcreId)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage('EBP Product Successfully Deleted', 'success');
                }
                this.WellsStore.getWellCloseReview();
            });
            this.formatDataTable();
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previousButton' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/productsreview');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/wellclose/intervalcostreview');
        }
    }

    public render() {
        const wellCloseReview = this.state.wellCloseReview;
        const wellId = this.props.match.params.wellId;
        if (wellCloseReview === undefined) {
            return <div>
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems}/>
            </div>;
        }
        return <div>
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
            <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems}/>
            <CostsTotalHeader />
            <Row>
                <Col>
                    <DataTable
                        list={this.state.dataSet}
                        onNew={{
                            callback: this.toggleModal,
                            text: 'Add New EBP'
                        }}
                        onDelete={this.handleDelete}
                        delibleList={this.getDelibleList()}
                        />
                </Col>
            </Row>
            <ButtonRow>
                <WellRevertCloseButton />
                <WellCloseButton />
                <Link className="secondary btn btn-secondary" style={{marginRight: 10}} target="_blank" to={`/print/well/${wellId}/wellclosereviewpdf`} >Snapshot</Link>
                { this.WellsStore.canUpdateWell() && <EButton color="primary" name="save" onClick={this.updateWellCloseReview}>Save</EButton>}
                <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                <WellFooter />
            </ButtonRow>
            <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} style={{'maxWidth': 'fit-content'}} backdrop="static">
                    <ModalHeader toggle={this.toggleModal}>EBP List</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                <DataTable
                                    list={this.state.showMasterItems ? this.state.modalDataSetMaster : this.state.modalDataSet}
                                    onMultiSelect={this.handleMultiSelect}
                                    multiSelectChecked={this.state.showMasterItems ? this.state.newInventoryListMaster : this.state.newInventoryList}
                                />
                            </Col>
                        </Row>
                        <div className="add-table-row">
                            <Button color={this.state.showMasterItems ? 'outline-primary' : 'primary'} onClick={this.handleListToggle}>{this.state.showMasterItems ? 'View Regional EBP Items' : 'View Non-Regional EBP Items'}</Button>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" name="previous" onClick={this.toggleModal}>Cancel</Button>
                        <Button color="primary" name="save" onClick={this.handleSave}>Add</Button>                        
                    </ModalFooter>
                </Modal>
        </div>;
    }
}

export default withRouter(EbpReview);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/EbpReview.tsx